import { ASTGeneratedOutput, Generator } from "@core/services/common/Generator";
import { PartialDetailingState } from "@core/store/types/admin/statistic/detailing/detailingState";

export default function leads (
  limit: number,
  offset: number,
  filters: PartialDetailingState["filters"],
  fields: string[]
): ASTGeneratedOutput {
  const money = ["value", "currency"];
  const params = {
    exclude: [ ...fields?.map((item: string) => `items.${ item }`) ]
  };
  
  const gqlObject = {
    operation: "leads",
    
    fields: [
      {
        items: [
          {
            webmaster: [
              "id",
              "intId",
              "login"
            ]
          },
          "id",
          "status",
          {
            fields: [
              "clickId",
              "domain",
              "phone",
              "utm_campaign",
              "utm_content",
              "utm_medium",
              "utm_source",
              "utm_term",
              "additionalFields"
            ]
          },
          "remoteId",
          "createdAt",
          {
            offer: [
              "id",
              {
                detail: [
                  "name"
                ]
              }
            ]
          },
          {
            reward: [
              {
                advertiserWriteOff: money
              },
              {
                webmasterReward: money
              },
              "withdrawType",
              "unholdDate"
            ]
          },
          "calls",
          "callsCount",
          "comment",
          "cancelReason",
          "spamReason"
        ]
      },
      "count",
      "aggregates",
      "extras"
    ],
    
    variables: {
      filters: {
        type: "LeadListQueryFiltersRegistry",
        value: filters
      },
      limit: {
        type: "Int",
        value: limit
      },
      offset: {
        type: "Int",
        value: offset
      }
    }
    
  };
  
  return Generator.query(gqlObject, params);
}